import { init as initApm } from '@elastic/apm-rum';
import { ApmRoute as Route } from '@elastic/apm-rum-react';

/**
 * @description Function to initialize the Elastic APM Realtime user monitoring
 * @param {Object} - required paramerts for initializing the APM monitoring
 */
const initElasticAPM = _ref => {
  let {
    version
  } = _ref;
  if (process.env.NODE_ENV === 'development') return;
  const {
    APP_NAME,
    APM_SERVER_URL,
    BUILD_ENVIRONMENT
  } = process.env;
  if (process.env && (!APP_NAME || !APM_SERVER_URL)) return;
  const APM_RUM_CONFIG = {
    serviceName: APP_NAME,
    serverUrl: APM_SERVER_URL,
    environment: BUILD_ENVIRONMENT,
    serviceVersion: version
  };
  initApm(APM_RUM_CONFIG);
};
export { initElasticAPM, Route };